const getCroppedImageUrl = (cropper) => cropper?.getCroppedCanvas()?.toDataURL();

export {
  getCroppedImageUrl,
};
